import { jsx } from "@emotion/react/jsx-runtime";
import { Radio as Radio$1 } from "@mui/material";
import { forwardRef } from "react";
import { radioStyles, circleStyles, innerCircle } from "./Radio.styles.js";
const CircleIcon = ({
  children
}) => /* @__PURE__ */ jsx("span", { css: circleStyles, className: "Sunbeam-radio-outline", children });
const CheckedIcon = () => /* @__PURE__ */ jsx(CircleIcon, { children: /* @__PURE__ */ jsx("div", { css: innerCircle, className: "Sunbeam-inner-circle" }) });
const Radio = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(Radio$1, { css: radioStyles, icon: /* @__PURE__ */ jsx(CircleIcon, {}), checkedIcon: /* @__PURE__ */ jsx(CheckedIcon, {}), ref, ...props });
});
export {
  Radio
};
//# sourceMappingURL=Radio.js.map
